export default __webpack_public_path__ + "static/media/background_light.45afcb89.jpeg";